<template>
	<validation-observer ref="observer" v-slot="{ handleSubmit }">
		<b-form v-on:submit.stop.prevent="handleSubmit( onSubmit )">
			<b-form-row>
				<b-col md="7">
					<validation-provider v-slot="validationContext" name="Product Description" v-bind:rules="{ required: true }" vid="description">
						<b-form-input id="product-description" v-model="product.description" placeholder="Prize Description" v-bind:state="getValidationState( validationContext )"></b-form-input>
						<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
					</validation-provider>
				</b-col>
				<b-col md="3">
					<validation-provider v-slot="validationContext" name="Product Quantity" v-bind:rules="{ required: true, min_value: 1 }" vid="quantity">
						<b-form-input id="product-quantity" v-model.number="product.quantity" placeholder="##" type="number" v-bind:state="getValidationState( validationContext )"></b-form-input>
						<b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
					</validation-provider>
				</b-col>
				<b-col md="2">
					<b-button :disabled="product.project.locked" class="mr-2" pill type="submit" variant="success">
						<b-icon aria-hidden="true" icon="check"></b-icon>
					</b-button>
					<b-button :disabled="product.project.locked" pill type="button" variant="danger" @click="onDelete">
						<b-icon aria-hidden="true" icon="trash"></b-icon>
					</b-button>
				</b-col>
			</b-form-row>
			<b-form-row>
				<b-col class="mt-2" md="10">
					<validation-provider v-slot="validationContext" name="Supplier" v-bind:rules="{ required: true }" vid="supplier">
						<b-form-group ref="product-supplier" label-for="product-supplier">
							<autocomplete id="product-supplier" v-model="product.supplier" endpoint="/suppliers/search/{token}" label-key="name" place-holder="Supplier" v-bind:validation-context="validationContext"></autocomplete>
						</b-form-group>
					</validation-provider>
				</b-col>
			</b-form-row>
		</b-form>
	</validation-observer>
</template>

<script>
import { PROJECT_PRODUCTS_REMOVE, PROJECT_PRODUCTS_SAVE } from '../store/actions/project'
import Autocomplete from '../components/Autocomplete'

export default {
	name: 'PrizeTile',

	props: {
		value: Object,
	},

	components: { Autocomplete },

	data () {
		return {
			product: this.value
		}
	},

	methods: {
		getValidationState ({ dirty, validated, valid = null }) {
			return dirty || validated ? valid : null
		},

		async onSubmit () {
			this.$refs['observer'].reset()

			this.$axios.put(`/products/${this.product.id}`, this.product)
				.then(response => {
					this.$store.commit(PROJECT_PRODUCTS_SAVE, response.data)
				})
		},

		async onDelete () {
			this.$bvModal.msgBoxConfirm(`Are you sure you want to delete '${this.product.description}'?`)
				.then(answer => {
					if (answer) {
						this.$axios.delete(`/products/${this.product.id}`)
							.then(() => {
								this.$store.commit(PROJECT_PRODUCTS_REMOVE, this.product)
							})
					}
				})

		}
	}
}
</script>
